import {
  GET_LIST_BANHANGTRAGOP,
  GET_LIST_BANHANGTRAGOP_SUCCESS,
  GET_LIST_BANHANGTRAGOP_FAILURE,
} from "actions/BanHangTraGop/actionTypes";

const initialState = {
  getListTraGopLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
  dataSearch: {},
};

const getListBanHangTraGop = (state, action) => ({
  ...state,
  getListTraGopLoading: true,
  dataSearch: action.dataSearch,
});

const getListBanHangTraGopSuccess = (state, action) => {
  return {
    ...state,
    getListTraGopLoading: false,
    objList: action.payload,
  };
};

const getListBanHangTraGopFailed = (state, action) => ({
  ...state,
  getListTraGopLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const banHangTraGopReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_BANHANGTRAGOP:
      return getListBanHangTraGop(state, action);
    case GET_LIST_BANHANGTRAGOP_SUCCESS:
      return getListBanHangTraGopSuccess(state, action);
    case GET_LIST_BANHANGTRAGOP_FAILURE:
      return getListBanHangTraGopFailed(state, action);
    default:
      return state;
  }
};

export default banHangTraGopReducer;
